/* CGN "Make it a double" upsell: adds current game + second game in one go */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function bubble(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inner = doc.querySelector('.shopify-section');
    var el = document.getElementById('cart-icon-bubble');
    if (inner && el) {
      el.innerHTML = inner.innerHTML;
      el.classList.add('cgn-bump');
      setTimeout(function () { el.classList.remove('cgn-bump'); }, 600);
    }
  }
  function flash(btn) {
    var r = btn.getBoundingClientRect();
    var f = document.createElement('span');
    f.className = 'cgn-up-flash';
    f.textContent = '-15%';
    f.style.left = (r.left + r.width / 2 - 24) + 'px';
    f.style.top = (r.top - 10) + 'px';
    document.body.appendChild(f);
    setTimeout(function () { f.remove(); }, 1000);
  }
  function toast(msg) {
    var t = document.querySelector('[data-toast]');
    if (!t || !t.querySelector('[data-toast-msg]')) return;
    t.querySelector('[data-toast-msg]').textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 4500);
  }

  function init(box) {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    var pdp = box.closest('[data-cgn-pdp]') || document;
    box.querySelectorAll('[data-up-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-loading') || btn.classList.contains('is-done')) return;
        btn.classList.add('is-loading');
        var mainInput = pdp.querySelector('[data-variant-id]');
        var mainId = mainInput ? parseInt(mainInput.value, 10) : null;
        var product = null;
        try { product = JSON.parse(pdp.querySelector('[data-cgn-product]').textContent); } catch (e) {}
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var hasMain = product && cart.items.some(function (i) { return i.product_id === product.id; });
            var items = [];
            if (mainId && !hasMain) items.push({ id: mainId, quantity: 1 });
            items.push({ id: parseInt(btn.dataset.upAdd, 10), quantity: 1 });
            return fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items, sections: 'cart-icon-bubble', sections_url: window.location.pathname })
            });
          })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            btn.classList.remove('is-loading');
            if (res.status && res.description) { toast(res.description); return; }
            bubble(res.sections && res.sections['cart-icon-bubble']);
            btn.classList.add('is-done');
            btn.querySelector('.cgn-up__add-txt').textContent = box.dataset.added || 'Added ✓';
            flash(btn);
            toast(box.dataset.toastText || 'Pair added — 15% off applied at checkout');
          })
          .catch(function () { btn.classList.remove('is-loading'); });
      });
    });
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-upsell]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
